'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useState, Fragment } from 'react';
import ApplicationForm from 'shared/components/ApplicationForm';
import Cta from 'shared/components/CtaBtn';
import { Card, Container, Col, Row, Button, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { useParams, useRouter } from 'next/navigation';
import dayjs from '../../utils/dayjs';
import { MdChevronLeft, MdOutlineShare } from 'react-icons/md';
import {
  FacebookShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  EmailShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
} from 'react-share';
import CompanyTeaser from '../../components/CompanyTeaser';
import AgencyTeaser from '../../components/AgencyTeaser';
import HappyAtSynergie from '../../components/HappyAtSynergie';
import SandYouJobOwner from '../../components/SandYouJobOwner';
import SandYouTeaser from '../../components/SandYouTeaser';
import JobLikeButton from '../../components/JobLikeButton';
import capitalizeFirstLetter from '../../utils/capitalizeFirstLetter';
import formatSalaryString from '../../utils/formatSalaryString';
import { useUser } from '../../contexts/UserContext';
import { Dictionaries, Locale } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';
import SynergieDivisionTeaser from '../../components/SynergieDivisionTeaser';

function scrollToForm() {
  const formPosition = document.getElementById('applicationForm');
  formPosition?.scrollIntoView({ behavior: 'smooth' });
}

function SharedJobDetailPage({
  job,
  className,
  dictionary,
}: {
  job: any;
  className?: string;
  dictionary: Partial<Dictionaries>;
}): JSX.Element {
  const { formatMessage } = getI18nUtils(dictionary);
  const { back, push } = useRouter();
  const [shareDropdownOpen, setShareDropdownOpen] = useState(false);
  const { jobApplications } = useUser();
  const { locale }: { locale: Locale } = useParams();

  const toggleShareDropdown = () => setShareDropdownOpen((prev) => !prev);

  const app = process.env.NEXT_PUBLIC_APP;
  const werkenbij = app === 'werkenbijsynergie.be';
  const sandyou = app === 'sandyou.be' || job?.agency?.apps?.includes('sandyou.be');
  const hasApplied = jobApplications?.some((application) => application.job?._id === job.id);

  function goBack() {
    let href = `/${locale}/jobs`;

    if (werkenbij) href = `/jobs`;
    if (window.history) {
      if (window.history.length > 1) back();
      else push(href);
    } else push(href);
  }

  let shareURL = `https://www.${app}/${locale}${job.uri}`;

  if (werkenbij) shareURL = locale === 'fr' ? `https://www.travaillerchezsynergie.be${job.uri}` : `https://www.${app}${job.uri}`;

  const formattedSalaryString = formatSalaryString(job);

  return (
    <div className={`job ${className || ''}`}>
      <Container>
        <Row>
          <Col lg={{ order: 1, size: 8 }}>
            <Row>
              <Col xs={{ order: 1 }} md={{ size: 8, order: 1 }}>
                <div className="d-flex justify-content-center justify-content-md-start">
                  <Button
                    color="white"
                    style={{ outline: 'none', boxShadow: 'initial' }}
                    onClick={() => goBack()}
                    className="ps-0 py-0 pe-4 d-flex align-items-center text-primary"
                  >
                    <MdChevronLeft size="20" className="me-3" />
                    {formatMessage({ id: 'job-back-to-result' })}
                  </Button>
                </div>
              </Col>
              <Col
                xs={{ order: 3 }}
                md={{ size: 4, order: 2 }}
                className="mb-3 mt-2 mb-md-0 mt-md-0 d-flex justify-content-center justify-content-md-end"
              >
                <JobLikeButton job={job} withText dictionary={dictionary} />
                <Dropdown
                  id="share-dropdown"
                  isOpen={shareDropdownOpen}
                  toggle={toggleShareDropdown}
                  onMouseLeave={() => setShareDropdownOpen(false)}
                >
                  <DropdownToggle id="share-button" className="d-flex align-items-center ms-2">
                    <MdOutlineShare />
                    <span className="ms-2 text-nowrap">{capitalizeFirstLetter(formatMessage({ id: 'job-share' }))}</span>
                  </DropdownToggle>
                  <DropdownMenu end id="share-menu">
                    <FacebookShareButton url={shareURL} className="d-flex align-items-center px-3 py-1 mb-2">
                      <FacebookIcon size={32} round />
                      <span className="ms-3 text-nowrap">
                        {capitalizeFirstLetter(formatMessage({ id: 'job-share-facebook' }))}
                      </span>
                    </FacebookShareButton>
                    <WhatsappShareButton url={shareURL} title={job.title} className="d-flex align-items-center px-3 py-1 mb-2">
                      <WhatsappIcon size={32} round />
                      <span className="ms-3 text-nowrap">
                        {capitalizeFirstLetter(formatMessage({ id: 'job-share-whatsapp' }))}
                      </span>
                    </WhatsappShareButton>
                    <LinkedinShareButton
                      title={job.title}
                      summary={formatMessage({ id: 'SEO-description-job' }, { jobTitle: job.title })}
                      source={job.uri}
                      url={shareURL}
                      className="d-flex align-items-center px-3 py-1 mb-2"
                    >
                      <LinkedinIcon size={32} round />
                      <span className="ms-3 text-nowrap">
                        {capitalizeFirstLetter(formatMessage({ id: 'job-share-linkedin' }))}
                      </span>
                    </LinkedinShareButton>
                    <EmailShareButton url={shareURL} subject={job.title} className="d-flex align-items-center px-3 py-1 mb-2">
                      <EmailIcon size={32} round />
                      <span className="ms-3 text-nowrap">{capitalizeFirstLetter(formatMessage({ id: 'job-share-email' }))}</span>
                    </EmailShareButton>
                  </DropdownMenu>
                </Dropdown>
              </Col>
              <Col xs={{ order: 2 }} md={{ size: 12, order: 3 }}>
                <div className="d-flex justify-content-start align-items-center">
                  <h1 className="my-3 text-center text-md-start">{job.title}</h1>
                  {hasApplied && (
                    <div className="pill pill-success ms-3 text-nowrap">{formatMessage({ id: 'status_applied' })}</div>
                  )}
                </div>
              </Col>
            </Row>
            <Card id="jobSpecs" className="mb-4">
              <Row>
                <Col md={6}>
                  <ul className="jobSpecList">
                    {job.location && (
                      <li>
                        <span className="jobLabel">{formatMessage({ id: 'job-detail-h3-location' })}</span>
                        {`${job.location.postalCode} ${job.location.city}`}
                      </li>
                    )}
                    {job.domains && job.domains.length >= 0 && (
                      <li className="text-lowercase">
                        <span className="jobLabel">{formatMessage({ id: 'job-detail-h3-job-category' })}</span>
                        {job.domains
                          .filter((domain) => !!domain)
                          .map((domain) => (
                            <span key={domain}>{formatMessage({ id: domain })} </span>
                          ))}
                      </li>
                    )}
                    {job.contractType && (
                      <li>
                        <span className="jobLabel">{formatMessage({ id: 'job-detail-h3-contracttype' })}</span>
                        <span>{formatMessage({ id: job.contractType })} </span>
                      </li>
                    )}
                    {/* {werkenbij && job.division && (
                      <li>
                        <span className="jobLabel">
                          <FormattedMessage id="division" />:
                        </span>
                        {job.division}
                      </li>
                    )} */}
                    {job.shifts && job.shifts.length > 0 && (
                      <li>
                        <span className="jobLabel">{formatMessage({ id: 'job-detail-h3-shifts' })}</span>
                        {job.shifts.map((shift, index) => (
                          <Fragment key={shift.id}>
                            {formatMessage({ id: shift.id })}
                            {index !== job.shifts.length - 1 ? ', ' : ''}
                          </Fragment>
                        ))}
                      </li>
                    )}
                    {formattedSalaryString && (
                      <li>
                        <span className="jobLabel">{formatMessage({ id: 'job-detail-h3-salary' })}</span>
                        {formattedSalaryString}
                      </li>
                    )}
                  </ul>
                </Col>
                <Col md={6}>
                  <ul className="jobSpecList">
                    {job.laborRegime && (
                      <li className="text-lowercase">
                        <span className="jobLabel">{formatMessage({ id: 'job-detail-h3-labor-regime' })}</span>
                        {formatMessage({ id: job.laborRegime.title || job.laborRegime })}
                      </li>
                    )}
                    {job.experience && (
                      <li>
                        <span className="jobLabel">{formatMessage({ id: 'job-detail-h3-working-experience' })}</span>
                        {formatMessage({ id: job.experience })}
                      </li>
                    )}
                    {job.updated && (
                      <li>
                        <span className="jobLabel">{formatMessage({ id: 'job-detail-h3-updated' })}</span>
                        <div>{dayjs(job.updated, 'x').format('DD/MM/YYYY HH:mm')}</div>
                      </li>
                    )}
                    {job.workPlaceType && (
                      <li>
                        <span className="jobLabel">{formatMessage({ id: 'job-detail-h3-workplace-type' })}</span>
                        <span>{formatMessage({ id: job.workPlaceType })} </span>
                      </li>
                    )}
                    {/* <li>
                            <span className="jobLabel">
                              <FormattedMessage id="job-detail-h3-working-experience" />:
                            </span>
                          </li> */}
                  </ul>
                </Col>
              </Row>
            </Card>
            <a
              onKeyDown={() => scrollToForm()}
              onClick={() => scrollToForm()}
              role="button"
              tabIndex={0}
              className="sticky d-lg-none"
            >
              <Cta className="cta red big">{formatMessage({ id: 'job-detail-button-apply-now' })}</Cta>
            </a>
            <div id="jobDescription">
              {job.description && (
                <section>
                  <h3>{formatMessage({ id: 'job-detail-h2-description' })}</h3>
                  <div dangerouslySetInnerHTML={{ __html: job.description }} />
                </section>
              )}
              {job.companyInformation && (
                <section>
                  <h3>{formatMessage({ id: 'job-detail-h2-companyinfo' })}</h3>
                  <div dangerouslySetInnerHTML={{ __html: job.companyInformation }} />
                </section>
              )}
              {job.profile && (
                <section>
                  <h3>{formatMessage({ id: 'job-detail-h2-profile' })}</h3>
                  <div dangerouslySetInnerHTML={{ __html: job.profile }} />
                </section>
              )}
              {job.offer && (
                <section>
                  <h3>{formatMessage({ id: 'job-detail-h2-offer' })}</h3>
                  <div dangerouslySetInnerHTML={{ __html: job.offer }} />
                </section>
              )}
              <section>
                <p>{formatMessage({ id: 'job-detail-inclusivity' })}</p>
              </section>
            </div>
          </Col>
          <Col lg={{ order: 3, size: 8 }} className="pt-3">
            <ApplicationForm dictionary={dictionary} jobId={job.id} />
          </Col>
          <Col lg={{ order: 2, size: 4 }}>
            <div className="sticky">
              <a onKeyDown={() => scrollToForm()} onClick={() => scrollToForm()} role="button" tabIndex={0}>
                <Cta className="cta red big" id="desktop">
                  {formatMessage({ id: 'job-detail-button-apply-now' })}
                </Cta>
              </a>
              {job.company && job.company.title && <CompanyTeaser company={job.company} dictionary={dictionary} />}
              {sandyou && <SandYouTeaser dictionary={dictionary} locale={locale} />}
              {werkenbij && !sandyou && <SynergieDivisionTeaser dictionary={dictionary} division={job.division} />}
              {sandyou && job.owner && <SandYouJobOwner dictionary={dictionary} owner={job.owner} className="border" />}
              {job.agency && !werkenbij && (
                <AgencyTeaser locale={locale} dictionary={dictionary} agency={job.agency} job prependBrandName={!sandyou} />
              )}
              {werkenbij && <HappyAtSynergie dictionary={dictionary} className="mt-3 border border-dark" />}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SharedJobDetailPage;
